import React, { useState, useEffect } from 'react';
import { X, Youtube } from 'lucide-react';
import { VideoUploadForm } from './VideoUploadForm';
import './YouTubeUploadModal.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export const YouTubeUploadModal = ({ isOpen, onClose, project, session }) => {
    const [isConnected, setIsConnected] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);

    useEffect(() => {
        if (isOpen && session?.access_token) {
            checkStatus();
        }
    }, [isOpen, session]);

    const checkStatus = async () => {
        setCheckingStatus(true);
        try {
            const res = await fetch(`${API_BASE}/api/youtube/status`, {
                headers: { Authorization: `Bearer ${session.access_token}` }
            });
            const data = await res.json();
            if (res.ok) {
                setIsConnected(data.connected);
            }
        } catch (err) {
            console.error('Failed to check YouTube status:', err);
        } finally {
            setCheckingStatus(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="youtube-upload-modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3><Youtube size={24} /> Upload to YouTube</h3>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <div className="modal-body">
                    <VideoUploadForm
                        session={session}
                        isConnected={isConnected}
                        preProject={project}
                        onUploadComplete={(res) => {
                            console.log("Upload complete:", res);
                            alert("Video uploaded successfully!");
                            onClose();
                        }}
                        onVideoSelect={() => { }} // No-op for modal preview
                    />
                </div>
            </div>
        </div>
    );
};
